<template>
    <div v-if="bizAuth.companyIntroduction.hasRight" class="page-setting biz-introl-setting parent-frame" :class="{'fixed': listIsFixed}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <button class="default-button publish" @click="save">儲存</button>
            </div>
        </div>
        <bussiness-introl-comp :submit="submitEnt"></bussiness-introl-comp>
    </div>
</template>
<script>
import bussinessIntrolComp from '@/components/bussiness/settingCenter/bussinessIntro/bussinessIntrolComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false,
            submitEnt: 0,
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.companyIntroduction.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        save: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.submitEnt += 1
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        }
    },
    components: {
        bussinessIntrolComp
    },
    computed: {
        ...mapGetters({
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/settingCenter/bussinessIntrol/bussinessIntrolDefault.vue